export default __webpack_public_path__ + "static/media/mke-zoo-humboldt-penguins.69535453.jpg";